/* This file is autogenerated, see readme.md for instructions */
import AnonymizeSvgIcon from '@bloomreach/banana-theme/icons/anonymize.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const AnonymizeIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <AnonymizeSvgIcon />
    </Icon>
  );
});

AnonymizeIcon.displayName = 'AnonymizeIcon';

export default AnonymizeIcon;
